// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"dc835341","324":"66f36ac4","890":"638ab1b2","921":"766e8344"}[chunkId] + ".chunk.js";
};